import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchApi } from "../components/tools" // Consumir api

export const getDashboard = createAsyncThunk(
    'dashboardAlumno/getDashboard',
    async (configObj) => {
        const data = await fetchApi({
            url: configObj.url,
            headers: configObj.headers,
            content: configObj.content
        })
        return data.msg[0]
    }
)

export const getPerfiles = createAsyncThunk(
    'dashboardAlumno/getPerfiles',
    async (configObj) => {
        const data = await fetchApi({
            url: configObj.url,
            headers: configObj.headers,
            content: configObj.content
        })
        return data.msg
    }
)

const dashboardAlumnoSlice = createSlice({
    name: 'dashboardAlumno',
    initialState: {
        data: [],
        ApiResponse: '',
        dataCta: [],
        dataPerfil: [],
        ApiResponsePerfiles: '',
        dataNotas: [],
        dataNoti: [],
        dataGNotas: []
    },
    reducers: {
        setCta: (state, action) => {
            state.dataCta = action.payload.data
        },
        setNotas: (state, action) => {
            state.dataNotas = action.payload.dNotas
        },
        setNoti: (state, action) => {
            state.dataNoti = action.payload.dNoti
        },
        setGraficaNotas: (state, action) => {
            state.dataGNotas = action.payload.dgNotas
        },
    },
    extraReducers: {
        [getDashboard.pending]: (state, action) => {
            state.ApiResponse = 'pending'
        },
        [getDashboard.fulfilled]: (state, action) => {
            state.data = action.payload
            state.ApiResponse = 'succeed'
        },
        [getDashboard.rejected]: (state, action) => {
            state.ApiResponse = 'rejected'
        },
        [getPerfiles.pending]: (state, action) => {
            state.ApiResponsePerfiles = 'pending'
        },
        [getPerfiles.fulfilled]: (state, action) => {
            state.dataPerfil = action.payload
            state.ApiResponsePerfiles = 'succeed'
        },
        [getPerfiles.rejected]: (state, action) => {
            state.ApiResponsePerfiles = 'rejected'
        },
    },
})
export const { setCta, setNotas, setNoti, setGraficaNotas } = dashboardAlumnoSlice.actions

export default dashboardAlumnoSlice.reducer